import {useSelector} from 'src/v2/state/store';
import {getDepositAmount} from 'src/utils/helpers';

export const useDepositAmount = (): number => {
  const amount = useSelector((state) => state.paymentDetails.amount);
  const assetCode = useSelector(
    (state) =>
      state.selectedCurrency?.assetCode ??
      state.directDeposit.selectedDirectDepositCurrency,
  );
  return getDepositAmount(amount, assetCode ?? '');
};
